// extracted by mini-css-extract-plugin
export var headerContent = "PageHeader-module--header-content--inJk0";
export var root = "PageHeader-module--root--hJ0Bu";